<template>
  <div>
    <parent-list-item v-if="isFolder" class="cursor-pointer" :file="item" :open="open" @click.native="open = !open" />
    <list-item v-else :file="item" :has-purchased="hasPurchased" />
    <d-expand-transition v-show="isFolder && open" v-if="hasPurchased">
      <div class="ml-10 border-l border-primary-500">
        <content-tree-node v-for="childItem in item.childItems" :key="childItem.id" :item="childItem" />
      </div>
    </d-expand-transition>
  </div>
</template>

<script>
  import ListItem from './ListItem.vue';
  import ParentListItem from './ParentItem.vue';

  export default {
    name: 'ContentTreeNode',
    components: {
      ListItem,
      ParentListItem,
    },

    inject: ['hasPurchased'],

    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        open: false,
      };
    },

    computed: {
      hasChildren() {
        return this.item.childItems != null && this.item.childItems.length > 0;
      },

      isFolder() {
        return this.item.type === 'Folder';
      },
    },
  };
</script>